const FormatHelper = {
    // 천 단위마다 콤마(,) 삽입
    addCommas: (nStr) => {
        nStr += '';
        var x = nStr.split('.');
        var x1 = x[0];
        var x2 = x.length > 1 ? '.' + x[1] : '';
        var rgx = /(\d+)(\d{3})/;
        while (rgx.test(x1)) {
                x1 = x1.replace(rgx, '$1' + ',' + '$2');
        }
        return x1 + x2;
    },

    // 숫자를 천단위는 K, 백만단위는 M, 십억단위는 B로 변환
    convertToKMB: (number) => {
        let views = number ? Number(number) : 0
        let string = views.toString()
        let length = string.length
        let units = ``
        let int = 0
        let first = 0
        //let second = 0
        if(views >= 1000000000) { // 1,000,000,000 십억
            units = `B`
            int = string.substring(0, length - 9)
            first = (length > 9) ? string.substring(length - 9, length - 8) : 0
            //second = (length > 10) ? string.substring(length - 8, length - 7) : 0
        }
        else if(views >= 1000000) { // 1,000,000 백만
            units = `M`       
            int = string.substring(0, length - 6)
            first = (length > 6) ? string.substring(length - 6, length - 5) : 0
            //second = (length > 7) ? string.substring(length - 5, length - 4) : 0
        }
        else if(views >= 1000) { // 1,000 천
            units = `K`
            int = string.substring(0, length - 3)
            first = (length > 3) ? string.substring(length - 3, length - 2) : 0
            //second = (length > 4) ? string.substring(length - 2, length - 1) : 0
        }
        else { // 1~999
            int = string
            first = 0
            //second = 0
        }

        //if(second > 0)         views = `${int}.${first}${second}${units}`
        if(first > 0)           views = `${int}.${first}${units}`
        else                    views = `${int}${units}`

        return views
    },

    convertToTagString: (input) => {
        input = input.replace(/[\{\}\[\]\/?.,;:|\)*~`!^\-_+<>@\$%&\\\=\(\'\"]/g, '')
        if (!input) return input
        
        input = input.replace(/ /gi, '#')

        let tryCount = 50
        while(--tryCount && input.includes('##')) {
            input = input.replace(/##/gi, '#')
        }

        if(input.length > 0 && input[0] !== '#') {
            input = `#${input}`
        }
        return input
    },

    removeTagStringSpecialCharacters: (input) => {
        return input.replace(/[\{\}\[\]\/?.,;:|\)*~`!^\-_+<>@\$%&\\\=\(\'\"]/g, '')
    }
}
export default FormatHelper;